import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";

//API
import ProcesosApi from "api/procesosApi";

const EditProcesoJudicial = ({ open, onClose, proceso, proceso_judicial, onSuccess }) => {
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    proceso: "",
    juzgado: "",
    email: "",
    demandante: "",
    demandado: "",
    radicado: "",
    estado_actual: "",
    mostrar_nota: false,
  });

  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     try {
  //     } catch (error) {
  //       console.error("Error al obtener los datos iniciales:", error);
  //       setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
  //     }
  //   };
  //   fetchInitialData();
  // }, []);

  useEffect(() => {
    if (proceso_judicial) {
      //alert("proceso_judicial: " + JSON.stringify(proceso_judicial));
      setFormData({
        ...proceso_judicial,
        proceso: proceso_judicial.proceso,
        juzgado: proceso_judicial.juzgado,
        email: proceso_judicial.email,
        demandante: proceso_judicial.demandante,
        demandado: proceso_judicial.demandado,
        radicado: proceso_judicial.radicado,
        estado_actual: proceso_judicial.estado_actual,
        mostrar_nota: proceso_judicial.mostrar_nota,
      });
    } else {
      setFormData({
        proceso: "",
        juzgado: "",
        email: "",
        demandante: "",
        demandado: "",
        radicado: "",
        estado_actual: "",
        mostrar_nota: false,
      });
    }
    setError(undefined);
  }, [proceso_judicial]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleanValue = value;
    setFormData((prev) => ({
      ...prev,
      [name]: cleanValue,
    }));
  };

  const resetState = () => {
    setError(undefined);
    setFormData({
      proceso: "",
      juzgado: "",
      email: "",
      demandante: "",
      demandado: "",
      radicado: "",
      estado_actual: "",
      mostrar_nota: false,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.juzgado === "") {
      setError("Debes registrar el Juzgado.");
      return;
    }
    try {
      //console.log("formData: " + JSON.stringify(formData));
      let newProcesoJudicial;
      if (proceso_judicial) {
        newProcesoJudicial = await ProcesosApi.actualizarProcesoJudicial(
          proceso.id,
          proceso_judicial.id,
          formData
        );
      } else {
        newProcesoJudicial = await ProcesosApi.crearProcesoJudicial(proceso.id, formData);
      }
      if (newProcesoJudicial) {
        resetState();
        onSuccess();
      }
    } catch (error) {
      console.error("Error al guardar los datos del Proceso Judicial:", error);
      setError(obtenerMensajeError(error, "Error al guardar los datos del Proceso Judicial."));
    }
  };

  const hCClose = () => {
    resetState();
    onClose();
  };

  const ESTADOS_PROCESO = [
    { value: "ACTIVO", label: "Activo" },
    { value: "INACTIVO", label: "Inactivo" },
    { value: "EN_TRAMITE", label: "En Trámite" },
    { value: "SUSPENDIDO", label: "Suspendido" },
    { value: "TERMINADO", label: "Terminado" },
  ];

  return (
    <Dialog open={open} onClose={hCClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        {proceso_judicial ? "Editar Proceso Judicial" : "Nueva Proceso Judicial"}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Juzgado
              </SuiTypography>
              <SuiInput name="juzgado" value={formData.juzgado} onChange={handleChange} />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Correo Electrónico
              </SuiTypography>
              <SuiInput name="email" value={formData.email} onChange={handleChange} />
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Demandante
              </SuiTypography>
              <SuiInput name="demandante" value={formData.demandante} onChange={handleChange} />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Demandado
              </SuiTypography>
              <SuiInput
                name="demandado"
                value={formData.demandado}
                onChange={handleChange}
                placeholder={
                  proceso?.cliente_detalle
                    ? `${proceso.cliente_detalle.nombre_completo}`.trim()
                    : "Nombre del demandado"
                }
              />
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={4}>
              <SuiTypography variant="h6" fontWeight="light">
                Radicado
              </SuiTypography>
              <SuiInput
                name="radicado"
                value={formData.radicado}
                onChange={handleChange}
                placeholder="(XXXXX-XX-XX-XXX-XXXX)"
              />
            </Grid>
            <Grid size={4}>
              <SuiTypography variant="h6" fontWeight="light">
                Estado Actual
              </SuiTypography>
              <Select name="estado_actual" value={formData.estado_actual} onChange={handleChange}>
                {ESTADOS_PROCESO.map((estado) => (
                  <MenuItem key={estado.value} value={estado.value}>
                    {estado.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item size={4}>
              <SuiTypography variant="h6" fontWeight="light" sx={{ mt: 2 }}>
                <Checkbox
                  checked={formData.mostrar_nota}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      mostrar_nota: e.target.checked,
                    }));
                  }}
                />
                {"  "}
                ¿Incluir la Nota: Se deja constancia de que a la fecha de...?
              </SuiTypography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark">
            {proceso_judicial ? "Actualizar" : "Registrar"}
          </SuiButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

EditProcesoJudicial.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  proceso: PropTypes.object,
  proceso_judicial: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default EditProcesoJudicial;
